// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module__wrapper___NLsTx","loading":"styles-module__loading___3g9l2"};